import { atomWithStorage } from 'jotai/utils';

/**
 * Whether a browser notification is raised when an agent run finishes while the
 * tab is in the background. Off until the user turns it on, since switching it
 * on is what prompts for notification permission.
 */
export const agentWorkbenchNotifyOnRunCompleteAtom = atomWithStorage(
	'agent-chat-notify-on-run-complete',
	false,
	undefined,
	{
		getOnInit: true,
	},
);
